import { FontWeight, ITheme } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<
  string,
  { labelPaddingTop: number; labelPaddingTopMobile: number },
  ITheme
>(
  {
    dropDown: {
      height: 48,

      '& > span': {
        zIndex: 0,
        height: 48,
        border: '2px solid #E7E7E7 !important',
        borderRadius: '12px !important',
        padding: '12px 16px !important',
        fontSize: '14px !important',
        lineHeight: '20px',
        fontWeight: '500 !important',
        '& > span': {
          marginLeft: 'auto',
        },
      },
      marginTop: 4,
    },
    popoverClass: {
      '& li': {
        fontWeight: FontWeight.Medium,
      },
    },
    error: {
      '& > span': {
        border: '2px solid var(--x-error-color) !important',
      },
    },
    button: {
      backgroundColor: 'var(--x-bg-12) !important',
    },
  },
  { name: 'generic-dropdown' },
);
export default useStyles;
